import React from 'react';
import './AboutUs.css';
import Header from '../HomePage/Header';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import HelpTrigger from '../HomePage/HelpTrigger';
import { FaCertificate, FaShippingFast, FaTags, FaUndoAlt } from 'react-icons/fa';
import ab1 from '../Images/ab1.jpg'
import ab2 from '../Images/ab2.jpg'
import ab3 from '../Images/ab3.webp'
import abv1 from "../Images/abv1.mp4";


const AboutUs = () => {
  return (
    <>
       <Header />
      <Navbar />
    <div className="about-us">
      {/* Hero Section */}
      <section className="about-hero">
        <img src="https://spinellejewelry.com/cdn/shop/files/pasted_image_0.jpg?v=1718708351&width=750" alt="Diamond Elegance" className="hero-image" />
        <div className="hero-text">
          <h1>Spinelle Diamond Jewellery</h1>
          <p>Unveiling Timeless Beauty Through Every Carat ✦</p>
        </div>
      </section>

      {/* Our Story */}
      <section className="about-story">
        <h2>Our Story</h2>
        <p>
          At Spinelle Diamond Jewellery, we believe that every diamond tells a story – a story of beauty,
          elegance, and timelessness. Based in the vibrant city of Hyderabad, our brand is dedicated to
          offering the finest natural diamonds, meticulously crafted into stunning pieces of jewelry that
          capture the essence of luxury and sophistication.
        </p>
        <p>
          Founded on the principles of quality, craftsmanship, and innovation, Spinelle has become
          synonymous with excellence. Our journey began with a passion for creating exquisite jewelry
          that not only enhances beauty but also celebrates the unique stories of our customers.
        </p>
        <p>
          We pride ourselves on sourcing only the highest quality natural diamonds, each carefully selected
          for its brilliance, purity, and exceptional characteristics. Our commitment to ethical sourcing
          and sustainability ensures that every Spinelle diamond is not only a symbol of beauty but also
          of responsible luxury.
        </p>

        {/* Image Collage */}
        <div className="image-collage">
          <img src={ab1} alt="Craftsmanship" />
          <img src={ab2} alt="Luxury Showroom" />
          <img src={ab3} alt="Ethically Sourced" />
        </div>
      </section>

      {/* Our Promise */}
      <section className="about-promise">
        <h2>Our Promise</h2>
        <div className="promise-cards">
          <div className="promise-card">
      <FaShippingFast />,
            <h3>Free Shipping</h3>
            <p>We offer fast & free shipping all over India</p>
          </div>
          <div className="promise-card">
       <FaUndoAlt />
            <h3>Easy Returns</h3>
            <p>Hassle-free return policy with full support</p>
          </div>
          <div className="promise-card">
            <FaTags />
            <h3>Competitive Pricing</h3>
            <p>Premium jewelry at the best price — always</p>
          </div>
          <div className="promise-card">
        <FaCertificate />
            <h3>Certified Jewelry</h3>
            <p>Each piece comes with authenticity certification</p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="about-reasons">
        <h2>Why Choose Spinelle?</h2>
        <ul>
          <li>✦ Award-winning designers & in-house artisans</li>
          <li>✦ Personalized custom-made jewelry for your story</li>
          <li>✦ Trusted by 10,000+ customers across India</li>
          <li>✦ Lifetime diamond upgrade & care support</li>
        </ul>
      </section>

      {/* Testimonial Section (Optional) */}
      <section className="about-testimonials">
        <h2>What Our Customers Say</h2>
        <div className="testimonial-slider">
          <p>“Absolutely in love with my engagement ring. The design, the sparkle — just wow!”</p>
          <span>– Radhika Sharma</span>
        </div>
        {/* You can add slider logic here */}
      </section>

      {/* Optional Brand Video */}
         <section className="video-banner-section">
           <video
             className="background-video"
             autoPlay
             muted
             loop
             playsInline
             src={abv1}
             type="video1/mp4"
           />
           <div className="video-overlay">
          
           </div>
         </section>
    </div>
      <Footer/>
         <HelpTrigger/>
    </>
  );
};

export default AboutUs;
